<div
  class="youtube-player__wrapper"
  [style.aspect-ratio]="aspectRation()"
  appLazyViewport
  (entered)="visible.set(true)"
>
  @let posterImage = poster();

  @if (posterImage && !started()) {
    <div class="youtube-player__poster">
      <div class="youtube-player__poster-gradient" aria-hidden="true"></div>

      <img
        class="youtube-player__poster-image"
        [ngSrc]="posterImage"
        fill
        priority
        alt="Youtube player poster"
      />

      <div class="youtube-player__poster-action">
        <app-button variant="secondary" ariaLabel="Click here to watch" (click)="onPosterClick()">
          Click here to watch
        </app-button>
      </div>
    </div>
  } @else if (showPlayer()) {
    <youtube-player
      class="youtube-player"
      placeholderImageQuality="high"
      [videoId]="videoId()"
      [width]="null"
      [height]="null"
      [playerVars]="playerVars()"
      (stateChange)="onPlayerStateChange($event)"
    />
  }
</div>
